import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-386c39d5")

_pushScopeId("data-v-386c39d5")
const _hoisted_1 = { class: "error" }
const _hoisted_2 = { class: "error__container" }
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"error__text\" data-v-386c39d5><div class=\"display-2\" data-v-386c39d5>Uh-oh!</div><div class=\"heading-6\" data-v-386c39d5> We&#39;re facing technical difficulties. </div><div class=\"error__subtext\" data-v-386c39d5> We&#39;re working to fix the problem, and will be up and running shortly. If you need help while the system is down, please drop us an <a href=\"mailto:hello@thoth.art\" data-v-386c39d5>email</a>. </div></div>", 1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_NavBar = _resolveComponent("NavBar")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_NavBar, { "logged-in": _ctx.isLoggedIn }, null, 8, ["logged-in"]),
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("img", {
          src: _ctx.errorImage,
          class: "error__image",
          alt: "error-image"
        }, null, 8, ["src"]),
        _hoisted_3
      ])
    ])
  ], 64))
})